// extracted by mini-css-extract-plugin
export default {"btn":"PanicButton_btn__PqsdX"};